export default __webpack_public_path__ + "static/media/Plt7.d4237fa9.png";